export default __webpack_public_path__ + "static/media/VITALS.47e1175e.png";